import {FilterObject} from '../../../shared/models/FilterBarObject';
import {EventAlert, EventAlertDetails} from '../../models/events/event-interface';
import {EventsFilter} from './events.model';

export class LoadMoreEventsResults {
  static type = '[Events] Load More Events Results';

  constructor(public resetChunk: boolean = false) {
  }
}

export class SelectEvent {
  static type = '[Events] Select Event';

  constructor(public event: EventAlert) {
  }
}
export class UpdateSelectedEvent {
  static type = '[Events] Update Select Event';

  constructor(public event: EventAlertDetails) {
  }
}
export class UpdateRealTimeEvents {
  static type = '[Events] Update Events';

  constructor(public events: EventAlert[]) {
  }
}

export class SetEventsFilter {
  static type = `[Events] Set Events Filter`;

  constructor(public filter: FilterObject<EventsFilter>) {
  }
}

export class GetEventsConfiguration {
  static type = `[Events] Get Events Configuration`;
}

export class SetIsPrinting {
  static type = `[Events] Set Is Printing`;

  constructor(public isPrinting: boolean) {
  }
}
